import { getValue, getFullUrl } from 'utils/utilityHelper'
import PersonList from './PersonList'
import List from "components/kanso/atoms/list/List"
import ListItem from "components/kanso/atoms/list/ListItem"
import Person from 'components/kanso/components/person/Person'
import Image from 'components/kanso/atoms/image/Image'

const PersonListAcousticData = (props) => {
  const { 
    personContentItems
  } = props.data
  
  return (
    <PersonList>
      <List>
        {personContentItems?.values?.map((content, index) => {
          console.log()
          return (
            <ListItem key={index}>
              <Person image={<Image src={getFullUrl(content?.elements?.image?.url)} mediaSrc={content?.elements?.image?.asset} altText="" />} name={getValue(content?.elements?.name)} role={getValue(content?.elements?.role)} />
            </ListItem>
          )
        })}      
      </List>
    </PersonList>
  )
}

export default PersonListAcousticData